module.exports = __webpack_public_path__ + "static/telegrotesknext-ultra-webfont-5f4bbdeda340ea2547658f04c8634442.woff2";